import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { StyledContainer } from '../styles';
import type { InputMaskProps } from '../types';

import InputMaskControl from './InputMaskControl';

export default function InputMask<T extends FieldValues>({
  control,
  helperText,
  label,
  mask,
  name,
  InputLabelProps,
  InputStyle,
  ...props
}: InputMaskProps<T>) {
  return (
    <StyledContainer {...props}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <InputMaskControl
            InputLabelProps={InputLabelProps}
            InputStyle={InputStyle}
            error={!!error}
            fullWidth
            helperText={(error?.message as string) || helperText}
            label={label}
            mask={mask}
            name={name}
            onChange={onChange}
            value={value}
          />
        )}
      />
    </StyledContainer>
  );
}
